<template>
    <ValidationObserver ref="observer" slim>
    <dialog class="mfa-popup-main-div country-popup-main-dev">
    <div class="titleSectionHeader">
        <span class="titleSectionHeaderTitleSpan">
            <h1 class="titleSectionHeaderTitle">{{$t( "helptopics.hklongmanloginpage.helptextheader")}}</h1>
        </span>
        <h1 id="headerTitleSR" class="sr-only"></h1>
        <a class="iconWrapper mfa-icon-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24px" height="24px">
                <path
                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
        </a>
        <hr>
    </div>
        <ul class="contentSection" id="popupListItem">
        <li tabindex="0" role="link">
            <div class="help_text_login_font"><b>{{$t( "helptopics.hklongmanloginpage.helptextCountry")}}</b></div>
            <div class="help_text_login_font">{{$t( "helptopics.hklongmanloginpage.helptextCountryD")}}</div>
        </li>
    </ul>
    </dialog>
        <b-form>
            <div v-if="typeof selfServiceDetails.error === 'string'">
                <b-alert variant="danger" show>
                    <p>{{selfServiceDetails.error}}</p>
                </b-alert>
            </div>
            <div v-else>
                <fr-social-buttons v-if="!isSocialReg" :signin="false"></fr-social-buttons>
                <b-form-group class="mb-0" v-for="(property, key) in userDetails" :key="key">
                    <fr-floating-label-input
                        :defaultValue="property.socialValue"
                        :fieldName="key"
                        :label="property.description"
                        :validateRules="calculateValidation(property)"
                        :disabled="shouldCopyEmailToUserName==true && property.title === 'Username'"
                        type="text"
                        v-model="saveDetails[key]"
                        @click="handleFocus"
                        @input="handleFocus"
                        >
                    </fr-floating-label-input>
                    <b-form-checkbox class="copy-email-checkbox" v-if="property.title === 'Username' && !revibe"  v-model="shouldCopyEmailToUserName" @change="onCheckboxChange">
                    {{ $t('pages.selfservice.registration.copyEmail') }}
                    </b-form-checkbox>
                </b-form-group>

                <div class="mobile-number-align" v-if="showMobileField">
                    <label class="ies-label mobile-text" for="phone-number">{{$t('pages.selfservice.registration.userDetails.mobilenumber')}}</label>
                    <div class="mobile-number">
                        <div class="custom-dropdown">
                            <div class="dropdown-selected" id="dropdown-selected">
                                <img id="selected-flag" src="https://flagsapi.com/US/shiny/32.png"
                                    alt="" />&nbsp;&nbsp;
                                <span id="selected-country"></span>
                                <img id="arrow-img" src="https://cdn-icons-png.flaticon.com/512/130/130907.png"
                                    alt="" />
                            </div>
                            <div class="dropdown-options" id="dropdown-options">
                        </div>
                    </div>
                    <span id="selected-dial-code"></span>
                    <input id="phone-number" name="phone-number" class="ies-input" @blur="handlePhoneNumber"/>
                    </div>
                    <div id="error-message"></div>
                </div>

                <ValidationProvider :rules="!ukStack ? 'required' : ''" v-slot="{ errors }" :name="translatedCountryName" v-if="!clinicalEuropeClientId">
                <div class="ies-label-group" v-if="!ukStack">
                  <div style='align-items: center; display: flex;' v-if="hklongman || certprep || skillingPartner || ukStack " >
                  <label class="ies-label" style='width:24%;' for="country">{{$t('pages.selfservice.registration.userDetails.selectcountry')}}</label>
                  <b-img :src="require('@/assets/images/pearson_help.png')" :title="$t('helptopics.hklongmanloginpage.helptextMsg')" rounded="circle" width="18" height="18" alt="img" id="help_icon_login1"/>
                  </div>
                    <select
                        name="country"
                        id="country"
                        v-model="handleCountryModel"
                        data-vv-validate-on="select|keyup|submit"
                        :class="{'ies-form-control custom-select ': true, 'invalid':  errors.length > 0}"
                        style="padding: 0.75rem 2.25rem 0.75rem 1rem"
                        :disabled="edExcelGateway"
                    >
                        <option value="" selected disabled>{{$t('pages.selfservice.registration.userDetails.selectcountry')}}</option>
                        <option v-for="(country, key) in countries" v-bind:value="country.Code" :key="key">
                            {{ country.Name }}
                        </option>
                    </select>
                    <div class="fr-validation-requirements text-left">
                        <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :rules="passwordValidation()" v-slot="{ errors }" :name="translatedPasswordField">
                    <div class="ies-label-group">
                        <label class="ies-label" for="ies-password">{{$t('pages.selfservice.registration.userDetails.password')}}</label>

                        <div class="ies-password-group">
                            <input autocomplete="new-password"  id="ies-password" :type="inputType" :class="{'ies-input-password ': true, 'invalid': errors.length > 0}" ref="password" :reveal="true" data-vv-validate-on="blur|submit" v-model="saveDetails.userPassword" :data-vv-as="$t('pages.selfservice.registration.userDetails.password')" @keydown.space="(event) => event.preventDefault()">
                            <div class="input-group-append">
                                <button aria-label="Reveal password as plain text" @click="revealText" :class="{'ies-form-control ies-pw-reveal-button ': true, 'error': errors.length > 0}" type="button">
                                    <i :class="[{'fa-eye': !showeyepwd}, {'fa-eye-slash': showeyepwd}, 'fa']"></i>
                                </button>
                            </div>
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider>
               <!-- <ValidationProvider rules="required|dob" v-slot="{ errors }" :name="translatedDOBField">
                    <div class="ies-label-group">
                        <label class="ies-label" for="ies-dob">{{$t('pages.selfservice.registration.userDetails.dob')}}</label>

                        <div class="ies-dob-group">
                            <input autocomplete="date" @input="checkConsentAge" id="ies-dob" type="text" :class="{'ies-input ': true, 'invalid': errors.length > 0}" ref="dob" data-vv-validate-on="blur|submit" v-model="saveDetails.dob" :data-vv-as="$t('pages.selfservice.registration.userDetails.dob')">
                        </div>
                        <div class="fr-validation-requirements text-left">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</span>
                        </div>
                    </div>
                </ValidationProvider> -->
                <ValidationProvider rules="required" v-if='revibe' v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="revibe" v-model="above18"
                                 @change="onCheckboxAbove18Change">
                                {{ $t("pages.selfservice.registration.revibe.ageConsent") }}
                            </b-form-checkbox>
                        </p>
                        <div class="fr-validation-requirements text-left" v-if='revibe'>
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.revibe.ageConsentError')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="hklongman" v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="hklongman" v-model="above18"
                                 @change="onCheckboxAbove18Change">
                                {{ $t("pages.selfservice.registration.hkConsent.consent1") }}
                            </b-form-checkbox>
                        </p>
                        <div class="fr-validation-requirements text-left" v-if="hklongman">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.userDetails.check1')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="hklongman" v-slot="{ errors }">
                    <div class="ies-label-group">
                        <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="hklongman" v-model="act"
                                 @change="onCheckboxACTChange">
                             {{ $t("pages.selfservice.registration.hkConsent.consent2") }}
                                <a href="https://loginstatic.pearson.com/html/LongmanHKPersonalInfoCollectionPolicy.html" target="_blank">
                                {{$t("pages.selfservice.registration.hkConsent.personalInfAnchorText")}}
                                &nbsp;&nbsp;&nbsp;{{$t("pages.selfservice.registration.hkConsent.coolectionStmAnchorText")}}
                                </a>
                            </b-form-checkbox>
                          </p>
                        <div class="fr-validation-requirements text-left" v-if="hklongman">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                             {{$t('pages.selfservice.registration.userDetails.check2')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-if="clinicalEuropeClientId" v-slot="{ errors }">
                    <div class="ies-label-group">
                       <p class="registration-consent-text disclaimer-align">
                            <b-form-checkbox plain v-if="clinicalEuropeClientId" v-model="disclaimer"
                                 @change="onCheckboxDisclaimer">
                                {{ $t("pages.selfservice.registration.regConsent.pearsonDisclaimerAgree") }}
                                <span class="text-danger">*</span>
                            </b-form-checkbox>
                            <a class="toggle-button" @click="toggle" :block="true">
                                <i :class="isExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            </a>
                        </p>
                        <div v-if="isExpanded" class="content">
                            <p>{{ $t("pages.selfservice.registration.regConsent.pearsonDisclaimerConsent") }}</p>
                        </div>
                        <div class="fr-validation-requirements text-left" v-if="clinicalEuropeClientId">
                            <span v-for="(error, index) in errors" :key="index" class="text-danger">
                            {{$t('pages.selfservice.registration.userDetails.disclaimer')}}</span>
                        </div>
                    </div>
                </ValidationProvider>
                        <p class="registration-consent-text">
                            <b-form-checkbox plain v-if="hklongman || certprep" v-model="keepInformed"
                                 :value="true"
                                 :unchecked-value="false">
                                 {{ $t("pages.selfservice.registration.regConsent.keepInformedConsent") }}
                            </b-form-checkbox>
                        </p>
            <!-- <fr-validation-error :validatorErrors="errors" :fieldName="key"></fr-validation-error> -->
            <b-button v-if="inline === false" @click="save" :block="true" size="lg" variant="primary">
                {{$t("common.form.signUp")}}
            </b-button>
        </div>
    </b-form>
    </ValidationObserver>
</template>

<script>
import _ from 'lodash';
import { isValidPhoneNumber, isPossiblePhoneNumber } from 'libphonenumber-js';
import SocialButtons from '@/components/utils/SocialButtons';
import FloatingLabelInput from '@/components/utils/FloatingLabelInput';
import countryList from '@/assets/json/countryList.json';
import countryListAR from '@/assets/json/countryList-AR.json';
import roleList from '@/assets/json/roleList.json';
import languageList from '@/assets/json/languageList.json';
import { CLIENT_ID, CLINICAL_EUROPE_DFLT_COUNTRY_CODE, FLAG_URL, MOBILENO_DROPDOWN } from '../../../utils/common';
import { getClientById, CLIENT } from '../../../lib/getClientById';
// import axios from 'axios';
import InputValidations from '@/components/utils/mixins/InputValidationsMixin';
import moment from 'moment';
import $ from 'jquery';
/**
 * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
 *
 **/
export default {
    name: 'User-Details',
    components: {
        'fr-floating-label-input': FloatingLabelInput,
        'fr-social-buttons': SocialButtons
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        },
        showeye: String,
        showeyepwd: String
    },
    mixins: [
        InputValidations
    ],
    data () {
        // const spEntityID = this.getQueryStringValue('spEntityID');
        const clientId = this.getQueryStringValue('clientId') || getClientById();
        let data = {
            userDetails: {},
            saveDetails: {},
            disabled: false,
            inputType: 'password',
            inputConfType: 'password',
            shouldCopyEmailToUserName: clientId === CLIENT.REVIBE,
            previousUid: '',
            userPreferences: {},
            isSocialReg: _.get(this.selfServiceDetails, 'tag') !== 'initial',
            countries: this.$i18n.locale.startsWith('ar') ? countryListAR : countryList,
            languages: languageList,
            roles: roleList,
            hklongman: getClientById() === CLIENT.HK_LONGMAN,
            edExcelGateway: getClientById() === CLIENT.ED_EXCEL_GATEWAY,
            certprep: getClientById() === CLIENT.CERT_PREP,
            edExcelGatewayCountry: 'GB',
            clinicalEuropeClientId: clientId?.includes('clinical-europe'),
            revibe: clientId === CLIENT.REVIBE,
            isExpanded: false,
            ukStack: getClientById() === CLIENT.UK_STACK,
            skillingPartner: getClientById() === CLIENT.SKILLING_PARTNER,
            mobileNumber: '',
            dialCode: '',
            dialCodeCountryList: MOBILENO_DROPDOWN.COUNTRY_LIST.sort((a, b) => a.name.localeCompare(b.name)),
            showMobileField: false
        };
        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationProperties) {
            data.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

            if (_.has(this.selfServiceDetails, 'requirements.properties.user.default') &&
                    !_.isUndefined(this.selfServiceDetails, 'requirements.properties.user.default')) {
                _.each(this.selfServiceDetails.requirements.properties.user.default, (value, key) => {
                    data.userDetails[key].socialValue = value;
                });
            }

            _.each(this.selfServiceDetails.requirements.registrationProperties.required, (prop) => {
                data.userDetails[prop].required = true;
            });

            _.each(this.selfServiceDetails.requirements.registrationProperties.properties, (value, key) => {
                data.saveDetails[key] = '';
            });
            _.each(data.userDetails, (value, key) => {
                value.description = this.$t('pages.selfservice.registration.userDetails.' + key);
            });
        }

        // data.saveDetails.userPassword = '';
        data.saveDetails.dn = 'pearsonuid=' + this.uuidv4() + ',ou=people,ou=external,dc=pearson,dc=com';
        data.saveDetails.pearsonCreatedBy = getClientById() === CLIENT.HK_LONGMAN ? 'HKLongman' : 'OneCRM';
        data.saveDetails.pearsonUserType = 'External';
        data.saveDetails.c = '';
        data.saveDetails.pearsonAppRole = '';
        data.saveDetails.preferredLanguage = '';
        data.saveDetails.upc = false;
        // if (this.$route.query.realm === undefined) {
        //     data.saveDetails.branding = 'PEARSON';
        // } else {
        //     data.saveDetails.branding = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
        // }
        return data;
    },
    created () {
        this.customValidations();
    },
    computed: {
        translatedCountryName () {
            return this.$t('pages.selfservice.registration.inputValidationMsg.country');
        },
        translatedPasswordField () {
            return this.$t('pages.selfservice.registration.inputValidationMsg.password');
        },
        translatedDOBField () {
            return this.$t('pages.selfservice.registration.userDetails.dob');
        },
        handleCountryModel: {
            get () {
                if (this.edExcelGateway) {
                    return this.edExcelGatewayCountry;
                } else {
                    return this.saveDetails.c;
                }
            },
            set (value) {
                this.saveDetails.c = value;
            }
        }
    },
    watch: {
        '$i18n.locale': {
            handler () {
                if (this.selfServiceDetails.requirements &&
                    this.selfServiceDetails.requirements.registrationProperties) {
                    this.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

                    // Update descriptions with new translations
                    _.each(this.userDetails, (value, key) => {
                        value.description = this.$t('pages.selfservice.registration.userDetails.' + key);
                    });

                    // Force re-render of the entire component
                    this.$nextTick(async () => {
                        const observer = this.$refs.observer;
                        if (observer) {
                            const providers = observer.refs;

                            for (const [, provider] of Object.entries(providers)) {
                                if (provider.errors.length > 0) {
                                    await provider.validate();
                                }
                            }
                        }
                        this.$forceUpdate();
                    });
                }
            },
            immediate: true
        }
    },
    mounted () {
        $('#help_icon_login').off('click').on('click', function (event) {
            $('.country-popup-main-dev').removeClass('slideIn');
            $('.country-popup-main-dev').removeAttr('open');
            $('.country-popup-main-dev').css('display', 'none');
            $('.select-popup-main-div').toggleClass('slideIn').show();
        });
        $('#help_icon_login1').off('click').on('click', function (event) {
            $('.country-popup-main-dev').toggleClass('slideIn').show();
            $('.select-popup-main-div').removeClass('slideIn');
            $('.select-popup-main-div').removeAttr('open');
            $('.select-popup-main-div').css('display', 'none');
        });
        $('.mfa-icon-btn').click(function () {
            $('.mfa-popup-main-div').removeClass('slideIn');
            $('.mfa-popup-main-div').hide();
        });
        this.populateDropdown();
        this.setDefaultCountry();
        $('#selected-dial-code').text('+1');
        this.dialCode = '+1';
        this.addPhoneValidation();
        this.setPhoneNumberInputProperties('US');
    },
    methods: {
        getData () {
            let details = _.clone(this.saveDetails);

            delete details.confirmPassword;

            if (this.isSocialReg) {
                delete details.userPassword;
            }
            details.cn = this.saveDetails.givenname + ' ' + this.saveDetails.sn;
            if (this.edExcelGateway) {
                details.c = this.edExcelGatewayCountry;
            }
            if (this.clinicalEuropeClientId) {
                details.c = this.getCountryCode();
            }
            if (this.showMobileField) {
                const updatedMobileNumber = this.formatPhoneNumberPattern(this.mobileNumber);
                details.telephoneNumber = `${this.dialCode}${updatedMobileNumber}`;
            }
            return {
                user: details
            };
        },
        onCheckboxChange () {
            if (this.shouldCopyEmailToUserName) {
                this.previousUid = this.saveDetails.uid;
                this.saveDetails.uid = this.saveDetails.mail;
            } else {
                this.saveDetails.uid = this.previousUid !== this.saveDetails.mail ? this.previousUid : '';
            }
        },
        onCheckboxAbove18Change () {
            if (this.above18) {
                this.above18 = true;
            } else {
                this.above18 = '';
            }
        },
        onCheckboxACTChange () {
            if (this.act) {
                this.act = true;
            } else {
                this.act = '';
            }
        },
        handleFocus (e) {
            if (this.shouldCopyEmailToUserName && this.saveDetails.uid !== this.mail) {
                this.saveDetails.uid = this.saveDetails.mail;
            } else if (e.target.getAttribute('name') === 'mail' && this.saveDetails.uid === '') {
                this.shouldCopyEmailToUserName = true;
                this.saveDetails.uid = this.saveDetails.mail;
            }
        },
        revealText: function () {
            if (this.inputType === 'password') {
                this.inputType = 'text';
                this.showeyepwd = true;
            } else {
                this.inputType = 'password';
                this.showeyepwd = false;
            }
        },

        revealconfirmText: function () {
            if (this.inputConfType === 'password') {
                this.inputConfType = 'text';
                this.showeye = true;
            } else {
                this.inputConfType = 'password';
                this.showeye = false;
            }
        },

        setDropdownValue (event) {
            if (event.target.name === 'language') {
                this.saveDetails.preferredLanguage = event.target.value;
            } else if (event.target.name === 'country') {
                this.saveDetails.c = event.target.value;
                this.$emit('countrySelectedUS', event.target.value === 'US');
            } else if (event.target.name === 'role') {
                this.saveDetails.pearsonAppRole = event.target.value;
            }
        },

        // Add additional frontend checks for field validation here
        calculateValidation (property) {
            let validators = [];
            // if (property.required) {
            validators.push('required');
            // }
            //
            if (property.title === 'First Name') {
                validators.push('regFNSpaceChk');
            } else if (property.title === 'Last Name') {
                validators.push('regLNSpaceChk');
            }

            if (property.title === 'Username') {
                validators.push('regUNSpaceChk');
                validators.push('regSpecialChar');
                validators.push('regUserAvailable');
                // validators.push('max:64');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                _.each(property.policies, (policy) => {
                    if (policy.policyId === 'maximum_length') {
                        validators.push('max:' + policy.params.maxLength);
                    } else if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    } else if (policy.policyId === 'minimum_length') {
                        validators.push('min:' + policy.params.minLength);
                    }
                    // _.each(policy.params, (param) => {
                    // });
                });
            }
            return validators.join('|');
        },
        checkConsentAge () {
            const parsedDate = moment(this.saveDetails.dob, 'MM-YYYY', true);
            const isValid = parsedDate.isValid() && parsedDate.endOf('month').isBefore(moment());
            if (!isValid) {
                this.$emit('toggle-keep-informed-visible', false);
                return;
            }
            const age = moment().diff(parsedDate.endOf('month'), 'years');
            const isOver18 = age >= 18;
            this.$emit('toggle-keep-informed-visible', isOver18);
        },
        // Add additional frontend checks for field validation here
        passwordValidation () {
            this.customValidations();

            let validators = [];
            validators.push('required');

            const id = getClientById();

            switch (id) {
            case CLIENT.HK_LONGMAN:
                validators.push('minChars');
                break;
            default:
                validators.push('max:120');
                validators.push('pwdSpecialChar');
                validators.push('pwdComplexPassword');
                validators.push('pwdIsNotInBannedList');
                validators.push('pwdIsUniqueComplexPassword');
                validators.push('pwdIsNotInBannedList');
            }
            return validators.join('|');
        },

        uuidv4 () {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        save () {
            // Need to ignore this validation because it does not preform in testing due to vue validate
            /* istanbul ignore next */
            this.isValid().then((valid) => {
                if (valid) {
                    this.$emit('advanceStage', this.getData());
                } else {
                    this.displayNotification('error', this.$t('pages.selfservice.registration.pleaseComplete'));
                }
            });
        },

        isValid () {
            /* istanbul ignore next */
            return this.$refs.observer.validate();
        },
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        },
        getCountryCode () {
            let countryCode = '';
            const clientId = this.getQueryStringValue('clientId') || getClientById();
            switch (clientId) {
            case CLIENT_ID.DANISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.DENMARK;
                break;
            case CLIENT_ID.DUTCH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.NETHERLAND;
                break;
            case CLIENT_ID.FRENCH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.FRANCE;
                break;
            case CLIENT_ID.GERMAN:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.GERMANY;
                break;
            case CLIENT_ID.NORWEGIAN:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.NORWAY;
                break;
            case CLIENT_ID.SPANISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.SPAIN;
                break;
            case CLIENT_ID.SWEDISH:
                countryCode = CLINICAL_EUROPE_DFLT_COUNTRY_CODE.SWEDEN;
                break;
            default:
                break;
            }
            return countryCode;
        },
        onCheckboxDisclaimer () {
            if (this.disclaimer) {
                this.disclaimer = true;
            } else {
                this.disclaimer = '';
            }
        },
        toggle () {
            this.isExpanded = !this.isExpanded;
        },
        formatPhoneNumberPattern (input) {
            return input.replace(/[^\d+]/g, '');
        },
        handlePhoneNumber (e) {
            const inputField = document.getElementById('phone-number');
            const errorElement = document.getElementById('error-message');
            const currentValue = e.target.value;
            this.mobileNumber = currentValue;
            if (currentValue.trim() === '') {
                inputField.className = 'ies-input';
                errorElement.style.color = '';
                errorElement.textContent = '';
            }
            if (this.isInvalidMobileNumber(currentValue) !== '') {
                const phoneLength = this.currentCountry.phoneLength;
                let maxLength;
                if (phoneLength) {
                    if (Array.isArray(phoneLength)) {
                        maxLength = phoneLength[phoneLength.length - 1];
                    } else if (typeof phoneLength === 'number') {
                        maxLength = phoneLength;
                    }
                }
                inputField.className = 'ies-input invalid';
                errorElement.className = 'text-danger';
                errorElement.textContent = `${this.$t('pages.selfservice.registration.userDetails.mobilenumbererror')} ${maxLength}${this.$t('pages.selfservice.registration.userDetails.mobilenumbererrorone')}`;
                return;
            }
            const result = this.validatePhoneNumber(currentValue, this.currentCountry);
            if (!result.valid) {
                inputField.className = 'ies-input invalid';
                errorElement.className = 'text-danger';
                errorElement.textContent = result.message;
            } else {
                inputField.className = 'ies-input';
                errorElement.style.color = '';
                errorElement.textContent = '';
            }
        },
        populateDropdown () {
            const selectedElement = document.getElementById('dropdown-selected');
            const optionsContainer = document.getElementById('dropdown-options');
            selectedElement.addEventListener('click', () => {
                event.stopPropagation();
                optionsContainer.style.display = optionsContainer.style.display === 'block' ? 'none' : 'block';
            });
            document.addEventListener('click', (event) => {
                if (!selectedElement.contains(event.target) && !optionsContainer.contains(event.target)) {
                    optionsContainer.style.display = 'none';
                }
            });
            document.addEventListener('keyup', (event) => {
                const isOpen = optionsContainer.style.display === 'block';
                if (isOpen) {
                    for (const item of optionsContainer.children) {
                        if (item.dataset.countryname.toLowerCase().startsWith(event.key.toLowerCase())) {
                            item.scrollIntoView({ behavior: 'smooth' });
                            break;
                        }
                    }
                }
            });
            this.dialCodeCountryList.forEach((country) => {
                const flagUrl = `${FLAG_URL}${country.code}.svg`;
                const optionDiv = document.createElement('div');
                optionDiv.setAttribute('data-country', JSON.stringify(country));
                optionDiv.setAttribute('data-countryname', country.name);
                const flagImage = document.createElement('img');
                flagImage.src = flagUrl;
                flagImage.alt = `${country.name} flag`;
                const countryName = document.createElement('span');
                countryName.textContent = country.name;
                optionDiv.appendChild(flagImage);
                optionDiv.appendChild(countryName);
                optionDiv.addEventListener('click', () => {
                    this.selectCountry(country);
                });
                optionsContainer.appendChild(optionDiv);
            });
        },
        selectCountry (country) {
            this.currentCountry = country;
            const selectedFlag = document.getElementById('selected-flag');
            selectedFlag.src = `https://flagsapi.com/${country.code}/shiny/32.png`;
            $('#selected-dial-code').text(country.dialCode);
            this.dialCode = country.dialCode;
            document.getElementById('dropdown-options').style.display = 'none';
            this.setPhoneNumberInputProperties(this.currentCountry);
            this.addPhoneValidation();
            const inputField = document.getElementById('phone-number');
            const errorElement = document.getElementById('error-message');
            inputField.className = 'ies-input';
            errorElement.style.color = '';
            errorElement.textContent = '';
            inputField.value = '';
        },
        setDefaultCountry () {
            const defaultCountry = this.dialCodeCountryList.find((country) => country.code === 'US');
            this.selectCountry(defaultCountry);
        },
        addPhoneValidation () {
            const phoneInput = document.getElementById('phone-number');
            phoneInput.addEventListener('input', () => {
                const phoneLength = this.currentCountry.phoneLength;
                let maxLength;
                if (phoneLength) {
                    if (Array.isArray(phoneLength)) {
                        maxLength = phoneLength[phoneLength.length - 1];
                    } else if (typeof phoneLength === 'number') {
                        maxLength = phoneLength;
                    }
                    phoneInput.value = phoneInput.value.replace(/\D/g, '');
                }
                if (maxLength === 10) {
                    this.formatPhoneNumber(phoneInput);
                }
            });
        },
        formatPhoneNumber (input) {
            const numbers = input.value.replace(/\D/g, '');
            input.value = numbers.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        setPhoneNumberInputProperties (country) {
            const phoneLength = country.phoneLength;
            if (phoneLength) {
                let maxLength;
                if (Array.isArray(phoneLength)) {
                    maxLength = phoneLength[phoneLength.length - 1];
                } else if (typeof phoneLength === 'number') {
                    maxLength = phoneLength;
                }
                const phoneInput = document.getElementById('phone-number');
                phoneInput.setAttribute('maxlength', maxLength);
            }
        },
        validatePhoneNumber (phoneNumber, countryCode) {
            const isValid = isValidPhoneNumber(phoneNumber, countryCode.code);
            const isPossible = isPossiblePhoneNumber(phoneNumber, countryCode.code);
            if (!isValid || !isPossible) {
                const phoneLength = countryCode.phoneLength;
                let maxLength;
                if (phoneLength) {
                    if (Array.isArray(phoneLength)) {
                        maxLength = phoneLength[phoneLength.length - 1];
                    } else if (typeof phoneLength === 'number') {
                        maxLength = phoneLength;
                    }
                }
                return { valid: false, message: `${this.$t('pages.selfservice.registration.userDetails.mobilenumbererror')} ${maxLength}${this.$t('pages.selfservice.registration.userDetails.mobilenumbererrorone')}` };
            } else {
                return { valid: true };
            }
        },
        isInvalidMobileNumber (mobile) {
            const mobileNo = this.formatPhoneNumberPattern(mobile);
            if (!/^\d{10}$/.test(mobileNo)) return 'Invalid format';
            const digits = mobileNo.split('').map(Number);
            if (_.uniq(digits).length === 1) {
                return 'Invalid number: repeating digits.';
            }
            let isIncreasing = true;
            let isDecreasing = true;
            for (let i = 1; i < digits.length; i++) {
                if (digits[i] !== digits[i - 1] + 1) isIncreasing = false;
                if (digits[i] !== digits[i - 1] - 1) isDecreasing = false;
            }
            if (isIncreasing || isDecreasing) {
                return 'Invalid number: sequential digits.';
            }
            return '';
        }
    }
};
</script>

<style scoped lang="scss">
@import '../../../scss/pearson-common.css';
</style>
